import React, { useState } from "react";
import TourList from "../components/TourList";
import AddTourModal from "../components/AddTourModal";
import { useNavigate } from "react-router-dom";
import TemplateList from "../components/TemplateList";
import AddTemplateModal from "../components/AddTemplateModal";
import Sidebar from "../components/Sidebar";

const EmailTemplateManagement = () => {
    const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const universityId = localStorage.getItem("universityId");

    const handleSaveTemplate = () => {
        console.log("Template saved. Refreshing list...");
        setRefreshList((prev) => !prev); // Toggle refreshList to trigger re-fetch
        setSelectedTemplate(null); // Clear selected tour after save
        setShowAddTemplateModal(false); // Close modal after saving
    };

    const handleEditTemplate = (template) => {
        setSelectedTemplate(template); // Set the selected tour for editing
        setShowAddTemplateModal(true);
    };

    return (
        <div className="dashboard">
            <Sidebar/>

            <main className="main-content">
                <header className="header component">
                    <span className="component-header">Email Templates</span>
                    <button
                        className="btn btn-primary action btn-new-template"
                        onClick={() => {
                            setSelectedTemplate(null); // Clear selected tour for new tour
                            setShowAddTemplateModal(true);
                        }}
                    >
                        <i className="fa fa-plus"></i> New Template
                    </button>
                </header>
                <p><a href="/dashboard"> Home </a> &gt; Email Templates </p>
                <hr/>

                <TemplateList
                    universityId={universityId}
                    refreshKey={refreshList} // This triggers a re-fetch in the TourList component
                    onEdit={handleEditTemplate}
                />

                {showAddTemplateModal && (
                    <AddTemplateModal
                        universityId={universityId}
                        template={selectedTemplate}
                        onClose={() => setShowAddTemplateModal(false)}
                        onSave={handleSaveTemplate} // Triggered when a tour is saved
                    />
                )}
            </main>
        </div>
    );
};

export default EmailTemplateManagement;